import { Link, RouteComponentProps } from '@reach/router';
import { ResourcesApi } from 'api/resourcesApi';
import EqualHeightsList from 'components/resources/EqualHeightsList';
import ResourcePageStatus from 'components/resources/ResourcePageStatus';
import {
  activityPath,
  awesomeStuffPath,
  isPageData,
  ResourcesRouteParams,
  usePageTitle,
  useResourcesPage,
} from 'components/resources/resourcesHelpers';
import ResourceSearchBox from 'components/resources/ResourceSearchBox';
import ResourceTile from 'components/resources/ResourceTile';
import SubjectSiteContainerFixed from 'components/subjectSite/SubjectSiteContainerFixed';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import React from 'react';

type Props = RouteComponentProps<ResourcesRouteParams>;

const ResourcesByActivity: React.FC<Props> = ({ subject: subjectCode }) => {
  const result = useResourcesPage(subjectCode, ResourcesApi.getActivities, '');
  usePageTitle(
    isPageData(result) ? `${result.subject.name} - Resources By Activity` : null
  );

  if (!isPageData(result)) return <ResourcePageStatus result={result} />;

  const { subject, labels, details } = result;
  const code = subject.internalCode;

  return (
    <SubjectSiteLayout colorCss="Blue_GSFPE">
      <SubjectSiteContainerFixed className="ResourceBankLanding">
        <div className="WidthContent">
          <div style={{ textAlign: 'left' }}>
            <Link
              to={awesomeStuffPath(code)}
              className="BtnFour BtnBack"
              aria-label="Back"
            >
              <span className="Icon_Four" />
              <span className="Txt_Four">Back</span>
            </Link>
          </div>
          <h1 className="Title">{labels.ActivityResourceBank ?? ''}</h1>
          <div className="TitleAndSearchWrapper">
            <ResourceSearchBox
              subjectCode={code}
              placeholder="Please enter search..."
            />
          </div>
          {details.activities.length === 0 ? (
            <p>No resources found.</p>
          ) : (
            <div className="VirtualPECupboard">
              <EqualHeightsList
                className="WarpperActivity WrapperList01"
                cardsSource={details}
              >
                {details.activities.map((activity) => (
                  <React.Fragment key={`${activity.bIsGroup}-${activity.id}`}>
                    {' '}
                    <ResourceTile
                      className="Item ItemList01"
                      colorCSS={activity.colorCSS}
                      name={activity.name}
                      imageSrc={activity.imagePath}
                      imageAlt={activity.name}
                      to={activityPath(code, activity.id, activity.bIsGroup)}
                    />
                  </React.Fragment>
                ))}
              </EqualHeightsList>
            </div>
          )}
        </div>
      </SubjectSiteContainerFixed>
    </SubjectSiteLayout>
  );
};

export default ResourcesByActivity;
